// TEST environment configuration
export const environment = {
  production: false,
  name: 'TEST',
  firebase: {
    apiKey: "AIzaSyAJbUKexbOGSgrKVBQvyBHllhOsurQPA6k",
    authDomain: "referentka-11e99.firebaseapp.com",
    projectId: "referentka-11e99",
    storageBucket: "referentka-11e99.appspot.com",
    messagingSenderId: "461993582336",
    appId: "1:461993582336:web:23b8c7b21b48b64b1b6f0f",
    measurementId: "G-Q5JNBHBW0N"
  },
  functionsRegion: 'europe-west3',
  lemonSqueezy: {
    storeId: 175439
  }
};
